// This file is auto-generated by "@aria-ui/cli". Do not edit this file directly.

import { registerTableHandleColumnMenuRootElement, type TableHandleColumnMenuRootElement, type TableHandleColumnMenuRootProps as TableHandleColumnMenuRootElementProps } from '@prosekit/web/table-handle';
import { createElement, forwardRef, useCallback, useRef, type ForwardedRef, type ForwardRefExoticComponent, type HTMLAttributes, type RefAttributes, useLayoutEffect } from 'react';

/** Props for the {@link TableHandleColumnMenuRoot} React component. */
export interface TableHandleColumnMenuRootProps {
  /**
   * Whether the overlay is initially open.
   * @default false
   */
  defaultOpen?: TableHandleColumnMenuRootElementProps['defaultOpen'];
  /**
   * Whether the overlay is currently open.
   * @default null
   */
  open?: TableHandleColumnMenuRootElementProps['open'];
  /**
   * Whether the component should ignore user interaction.
   * @default false
   */
  disabled?: TableHandleColumnMenuRootElementProps['disabled'];
}

function TableHandleColumnMenuRootComponent(props: TableHandleColumnMenuRootProps, forwardedRef: ForwardedRef<TableHandleColumnMenuRootElement>) {
  registerTableHandleColumnMenuRootElement();

  const elementRef = useRef<TableHandleColumnMenuRootElement>(null);

  const { defaultOpen: p0, disabled: p1, open: p2, ...restProps } = props;

  useLayoutEffect(() => {
    const element = elementRef.current as Record<string, unknown> | null;
    if (!element) return;
    Object.assign(element, { defaultOpen: p0, disabled: p1, open: p2 });
  });

  const mergedRef = useCallback(
    (element: TableHandleColumnMenuRootElement | null) => {
      elementRef.current = element;
      if (typeof forwardedRef === 'function') {
        forwardedRef(element);
      } else if (forwardedRef) {
        forwardedRef.current = element;
      }
    },
    [forwardedRef],
  );

  return createElement('prosekit-table-handle-column-menu-root', { ...restProps, ref: mergedRef, suppressHydrationWarning: true });
}

/** A React component that renders an `prosekit-table-handle-column-menu-root` custom element. */
export const TableHandleColumnMenuRoot: ForwardRefExoticComponent<TableHandleColumnMenuRootProps & HTMLAttributes<TableHandleColumnMenuRootElement> & RefAttributes<TableHandleColumnMenuRootElement>> = /* @__PURE__ */ forwardRef(TableHandleColumnMenuRootComponent);
